import { ADD, ADDTOCART, LESS } from "./actionType";

export let price = 0;

export const CartItems = { product: [], value: 0 };

const CartReducer = (state = CartItems, action) => {
  let items = state.product;

  function isExists(item) {
    return item.id === action.payload.id;
  }

  const exists = items?.find(isExists);
  switch (action.type) {
    case ADDTOCART:
      if (exists?.quantity === 0) {
        exists.stockOut = true;
      } else {
        if (exists) {
          exists.cartQuantity += 1;
          exists.stockOut = false;
          price += exists.price;
        } else {
          state?.product?.push(action.payload);

          price += action.payload.price;
        }
      }
      console.log(exists);

      return state;
    case ADD:
      if (action.payload.quantity === 0) {
        exists.stockOut = true;
      } else {
        price += action.payload.price;
        action.payload.cartQuantity += 1;
      }

      return state;
    case LESS:
      if (action.payload.quantity !== 0) {
        exists.stockOut = false;
        price -= action.payload.price;
        action.payload.cartQuantity -= 1;
      }

      return state;
    default:
      return state;
  }
};

export default CartReducer;
